import React from 'react';
import { FiMessageSquare } from 'react-icons/fi';

// Комментарий координатора к позиции — выделен, чтобы Sales его видел до брони.
function EquipmentComment({ text, compact = false, className = '' }) {
  if (!text || !String(text).trim()) return null;
  return (
    <div
      className={`flex items-start gap-2 rounded-md border-l-4 border-amber-400 bg-amber-50 text-amber-900 ${
        compact ? 'px-2 py-1 text-xs' : 'px-3 py-2 text-sm'
      } ${className}`}
    >
      <FiMessageSquare className="mt-0.5 h-4 w-4 flex-shrink-0 text-amber-500" aria-hidden="true" />
      <span className="min-w-0 whitespace-pre-line break-words">
        <span className="font-semibold">Комментарий: </span>
        {text}
      </span>
    </div>
  );
}

export default EquipmentComment;
